import { useEffect } from 'react';

const SubscriptionTemplate = ({ sub, unsub, listeners, socket, routes, from }) => {
	useEffect(() => {
		subAndAddListeners();
		listenForConnectChange();
		return () => {
			unsubAndRemoveListeners();
		};
	}, []);

	const listenForConnectChange = () => {
		socket.on('disconnect', reason => {
			if (reason === 'transport close') {
				console.log('Disconnect - unsubAndRemoveListeners', from);
				unsubAndRemoveListeners();
			}
		});
		socket.on('connect', () => {
			console.log('connect - subAndAddListeners', from);
			subAndAddListeners();
		});
	};

	const addListeners = () => {
		console.log('addlisteners', from);
		console.log(routes, listeners);
		listeners.forEach(listener => listener());
	};
	const removeListeners = () => {
		routes.forEach(route => {
			socket.off(route);
		});
	};

	const subAndAddListeners = () => {
		console.log('subAndAddListeners', from);
		sub();
		addListeners();
	};

	const unsubAndRemoveListeners = () => {
		console.log('unsubAndRemoveListeners', from);
		unsub();
		removeListeners();
	};

	return null;
};

export default SubscriptionTemplate;
